<template>
    <div>
        <div class="main-inner">
            <div class="row align-items-center mb-3">
                <div class="col-12 col-md-6 col-xl-4">
                    <h1 class="mb-0">Rollen & rechten</h1>
                </div>

                <div class="col-12 col-md-6 col-xl-4 text-right">
                    <router-link :to="{ name: 'addRole' }" class="btn btn-outline-primary" v-permission:manage_roles="currentUser">Rol toevoegen</router-link>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-8">
                    <Roles />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Roles from '@/components/roles/Roles';
    import {mapGetters} from 'vuex';

    export default {
        components: { Roles },

        computed: {
            ...mapGetters([
                'currentUser'
            ])
        }
    }
</script>